import { httpPost, httpGet } from "utils/httpRequest";

const getDailyPrime = async () => {
  const resp = await httpGet("client/dailyPrime/getDailyPrime");
  return resp.data;
};

export { getDailyPrime };
